import { applyBillingFilters } from 'src/app/shared/utils/billing-filter.utils';
import { Component, ElementRef, OnInit, ViewChild, OnDestroy, inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SettlementsService } from 'src/app/services/settlements.service';
import { ToastrService } from 'ngx-toastr';
import { FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { IconsService } from 'src/app/shared/services/icons.service';
import { GodModeService } from 'src/app/shared/services/god-mode.service';
import { NgbCalendar, NgbDate, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import { ImageService } from 'src/app/shared/services/image.service';
import { Subscription } from 'rxjs';

import * as bs from 'bootstrap';
import { FullFilterComponent } from 'src/app/components/offcanvas/full-filter.component';
import { Settlement } from 'src/app/models/settlement.model';
import { Building } from 'src/app/models/building.model';
import { Floor } from 'src/app/models/floor.model';
import { Unit } from 'src/app/models/unit.model';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-payments',
  template: `
    <div class="d-flex mb-4 mt-4">
      <div class="flex-fill">
        <h1>Recibos</h1>
        <xng-breadcrumb ></xng-breadcrumb>
      </div>
    </div>
    <div class="flex-fill">
      <div class="d-flex">
        <div class="me-3" style="width: 222px !important; min-width: 222px !important;">
          <ul #sidebar app-nav-payments [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
          <h4 class="mt-1 ms-3 mb-3" style="font-size: 1.2em">Reportes</h4>
          <ul class="list-unstyled">
            <li>
            <button class="btn btn-zazz-default active rounded-4 shadow-sm w-100 px-4 mb-3" (click)="downloadCSV()">
              <fa-icon [icon]="icons.faDownload" class="me-3" *ngIf="!downloading"></fa-icon>
              <fa-icon [icon]="icons.faCircleNotch" animation="spin" class="me-3" *ngIf="downloading"></fa-icon>
              Generar reporte
            </button>
            </li>
          </ul>
        </div>
        <div #pages class="flex-fill">
          <div class="d-flex">
            <div>
              <div ngbDropdown class="d-inline-block" (click)="datepicker.toggle()">
                <button type="button" 
                  class="btn btn-zazz-default rounded-4 px-4 shadow-sm" 
                  id="dropdownForm1" 
                  ngbDropdownToggle>
                  <fa-icon [icon]="icons.faCalendarAlt" class="me-2"></fa-icon>
                  Este mes
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownForm1" class="shadow" style="width: 650px;">
                  <div class="row" (click)="$event.stopPropagation()">
                    <div class="col-3">
                      <ul class="list-group calendar-list-group ps-2 mt-2">
                        <li #1day class="list-group-item list-group-item-action active">Hoy</li>
                        <li #yesterday class="list-group-item list-group-item-action">Ayer</li>
                        <li #1mes class="list-group-item list-group-item-action" (click)="updateFilter(1)">Este mes</li>
                        <li #3mes class="list-group-item list-group-item-action" (click)="updateFilter(3)">3 meses</li>
                        <li #6mes class="list-group-item list-group-item-action" (click)="updateFilter(6)">6 meses</li>
                        <li #12mes class="list-group-item list-group-item-action" (click)="updateFilter(12)">12 meses</li>
                        <li #custom class="list-group-item list-group-item-action">Personalizado</li>
                      </ul>
                    </div>
                    <div class="col-9" style="height: 320px;">
                      <div class="input-group">
                        <input
                          #dpFromDate
                          class="form-control"
                          style="width: 0px !important; height: 0px !important; opacity: 0;"
                          ngbDatepicker
                          #datepicker="ngbDatepicker"
                          [autoClose]="'outside'"
                          (dateSelect)="onDateSelection($event)"
                          [displayMonths]="2"
                          [dayTemplate]="t"
                          outsideDays="hidden"
                          [startDate]="fromDate!"
                          tabindex="-1" 
                        />
                        <ng-template #t let-date let-focused="focused">
                          <span
                            class="custom-day"
                            [class.focused]="focused"
                            [class.range]="isRange(date)"
                            [class.faded]="isHovered(date) || isInside(date)"
                            [class.selected]="date.equals(fromDate) || (toDate && date.equals(toDate))"
                            (mouseenter)="hoveredDate = date"
                            (mouseleave)="hoveredDate = null"
                          >
                            {{ date.day }}
                          </span>
                        </ng-template>
                      </div>
                    </div>
                  </div>                  
                </div>
              </div>
            </div>
            <div class="flex-fill">
              <button class="btn btn-zazz-default rounded-4 px-4 ms-2 shadow-sm" (click)="openFilters()">
                <fa-icon [icon]="icons.faSliders" class="me-2"></fa-icon>
                Filtrar búsqueda
              </button>
              <button class="btn btn-outline-secondary rounded-4 px-4 ms-2 shadow-sm" (click)="resetFilters()">
                <fa-icon [icon]="icons.faRotateLeft" class="me-2"></fa-icon>
                Limpiar filtros
              </button>
            </div>
            <div class="flex-fill ms-2">
              <!-- input type="text" class="form-control rounded-4 border border-1 border-secondary" placeholder="Buscar recibo" formControlName="search" -->
            </div>
          </div>
          <div class="flex-fill list-group rounded-4 shadow mt-4" >
            <div class="list-group-item" *ngIf="bills.length > 0">
              <table class="table table-sm mt-2">
                <thead class="thead-dark">
                  <tr class="">
                    <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-left-3 py-2 ps-3">
                      # Recibo 
                      <button class="btn p-0 text-light" (click)="sortBy('id')">
                        <fa-icon [icon]="getSortIcon('id')"></fa-icon>
                      </button>
                    </th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2">Unidad </th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2">Razón social</th>
                    <!-- th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Consumo</th -->
                    <th scope="col" *ngIf="payFilterPrefs.status" class="text-center bg-zazz align-items-center align-middle text-light py-2">Pago <button class="btn p-0 text-light"><fa-icon [icon]="icons.faSort"></fa-icon></button></th>
                    <th scope="col" *ngIf="!payFilterPrefs.status" class="text-center bg-zazz align-items-center align-middle text-light py-2">Total a pagar <button class="btn p-0 text-light"><fa-icon [icon]="icons.faSort"></fa-icon></button></th>
                    <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Vence <button class="btn p-0 text-light"><fa-icon [icon]="icons.faSort"></fa-icon></button></th>
                    <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Fecha pago <button class="btn p-0 text-light"><fa-icon [icon]="icons.faSort"></fa-icon></button></th>
                    <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Estatus</th>
                    <th scope="col" class="bg-zazz align-items-center align-middle text-light rounded-top-right-3 py-2"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr app-tr-payments
                    [bill]="bill"
                    [showLegalEntity]="true"
                    [profile]="profile" 
                    [permissions]="permissions"
                    (updateDate)="updateBillDate($event)"
                    *ngFor="let bill of bills | paginate: { itemsPerPage: payload.per_page, currentPage: p, totalItems: meta.total_entries }"
                  ></tr>
                </tbody>
              </table>
            </div>
            <div class="list-group-item" *ngIf="bills.length==0&&loading">
              <div class="text-center py-5">
                <fa-icon [icon]="icons.faCircleNotch" size="2x" animation="spin" class="text-secondary"></fa-icon>
                <p class="text-muted">Cargando...</p>
              </div>
            </div>
            <div class="list-group-item" *ngIf="bills.length==0&&!loading">
              <div class="text-center py-5">
                <img src="/assets/images/empty-state.png" width="240px">
                <p class="text-muted">No se encontraron registros</p>
              </div>
            </div>
            <div class="list-group-item text-center pt-3">
              <pagination-controls
                (pageChange)="p = $event"
                (pageChange)="pageChanged($event)"
                previousLabel="Prev."
                nextLabel="Sig."
                screenReaderPaginationLabel="Pagination"
                screenReaderPageLabel="page"
              ></pagination-controls>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-modal-set-bill-date [bill]="selectedBill"></app-modal-set-bill-date>
  `,
  styleUrls: []
})
export class PaymentsComponent implements OnInit, OnDestroy {
  apiUrl: string = environment.AWS_REST_WSPREFIX;
  bills: any = [];
  meta: any = {};
  profile: any = {};
  permissions: any = {};
  godmode: boolean = false;
  searchBox: FormGroup = new FormGroup({});

  @ViewChild('1day') oneDay !: ElementRef;
  @ViewChild('yesterday') yesterday !: ElementRef;
  @ViewChild('1mes') oneMonth !: ElementRef;
  @ViewChild('3mes') threeMonth !: ElementRef;
  @ViewChild('6mes') sixMonth !: ElementRef;
  @ViewChild('12mes') twelveMonth !: ElementRef;
  @ViewChild('custom') custom !: ElementRef;
  @ViewChild('datepicker') datepicker: any;

  selectedBill: any = null;

  currentView: string = 'payments';

  searchActive: boolean = false;
  loading: boolean = false;

  payload: any = {
    page: 1,
    per_page: 100,
    status: true,
    state: [1,2],
    created_at_since: '',
    created_at_to: '',
    sort: 'paid_date',
    order: 'ASC'
  }

  a = new Date();
  fromDate; // : any = "2023/12/01"; // Date = new Date();
  toDate: NgbDate | null;

  p: number = 1;

  settlements: Settlement[] = [];
  buildings: Building[] = [];
  floors: Floor[] = [];
  units: Unit[] = [];

  downloading: boolean = false;

  transactionList: any = [];

  payFilterPrefs: any = {};

  hoveredDate: NgbDate | null = null;

  currentSortField: string = 'id';
  currentSortOrder: 'ASC' | 'DESC' = 'ASC';

  private godModeSubscription: Subscription = new Subscription();
  storageService = inject(StorageService);
  constructor(
    private store : SettlementsService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    public icons: IconsService,
    public images: ImageService,
    private godModeService: GodModeService,
    private offcanvasService: NgbOffcanvas,
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;
    this.godmode = this.godModeService.getGodMode();
    // this.payload.profile_id = null; //this.profile.id;

    const adjustedDate = new Date(this.a.getFullYear(), this.a.getMonth(), this.a.getDate());
    const lastDay = new Date(this.a.getFullYear(), this.a.getMonth() + 1, 0);

    this.fromDate = new NgbDate(adjustedDate.getFullYear(), adjustedDate.getMonth()+1, 1);
    this.toDate = new NgbDate(this.a.getFullYear(), this.a.getMonth()+1, lastDay.getDate());

    this.payload.created_at_since = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
    this.payload.created_at_to = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;

    this.payFilterPrefs = this.storageService.getItem(STORAGE_KEYS.PAYFILTERSPREFS) ? this.storageService.getItem(STORAGE_KEYS.PAYFILTERSPREFS) : this.payload;
    this.payFilterPrefs.state = [1,2];
    this.payFilterPrefs.status = true;
    this.payFilterPrefs.created_at_since = this.payload.created_at_since;
    this.payFilterPrefs.created_at_to = this.payload.created_at_to;
    // this.payFilterPrefs.profile_id = null; // this.profile.id;
    if (!this.godmode) {
      this.payFilterPrefs.profile_id = this.profile.id; // Set profile_id for non-godmode users
    } else {
      delete this.payFilterPrefs.profile_id;
    }
    this.payFilterPrefs.all = true;
    this.p = this.payFilterPrefs.page;

    this.loadBills(this.payFilterPrefs);
  }

  ngOnInit(): void {
    // Subscribe to god mode changes
    this.godModeSubscription = this.godModeService.godMode$.subscribe(
      (godMode: boolean) => {
        this.godmode = godMode;
        // Update payFilterPrefs based on god mode
        if (!this.godmode) {
          this.payFilterPrefs.profile_id = this.profile.id;
        } else {
          delete this.payFilterPrefs.profile_id;
        }
        // Reload bills when god mode changes
        this.loadBills(this.payFilterPrefs);
      }
    );

    setTimeout(() => {
      this.datepicker.open();
    });
  }

  ngOnDestroy(): void {
    this.godModeSubscription.unsubscribe();
  }

  updateDate(event: any) {
    this.fromDate = event.from;
    this.toDate = event.to;

    if (this.toDate?.after(this.fromDate) || this.toDate?.equals(this.fromDate)) {
      this.payFilterPrefs.created_at_since = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
      this.payFilterPrefs.created_at_to = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;
      this.loadBills(this.payFilterPrefs);
    }
  }

  sortBy(field: string) {
    if (this.currentSortField === field) {
      // Toggle order if clicking the same field
      this.currentSortOrder = this.currentSortOrder === 'ASC' ? 'DESC' : 'ASC';
    } else {
      // Set new field and default to ASC
      this.currentSortField = field;
      this.currentSortOrder = 'ASC';
    }

    this.payFilterPrefs.sort = field;
    this.payFilterPrefs.order = this.currentSortOrder;
    this.loadBills(this.payFilterPrefs);
  }

  getSortIcon(field: string) {
    if (this.currentSortField !== field) {
      return this.icons.faSort;
    }
    return this.currentSortOrder === 'ASC' ? this.icons.faSortUp : this.icons.faSortDown;
  }

  loadBills(payload: any) {
    this.loading = true;
    this.bills = [];
    this.store.getBillsQuery(payload).subscribe({
      next: (data: any) => {
        this.bills = data.data;
        this.meta = data.meta;
        this.loading = false;
        this.storageService.saveItem(STORAGE_KEYS.PAYFILTERSPREFS, this.payFilterPrefs);
        
      }, error: (err: any) => {
        this.loading = false;
      }
    });
  }

  openFilters() {
    const offcanvasRef = this.offcanvasService.open(FullFilterComponent, {
      position: 'end',
      animation: true,
      backdrop: true,
      keyboard: true,
      scroll: true,
      backdropClass: 'bg-dark',
      panelClass: 'bg-light',
    });

    offcanvasRef.componentInstance.payload = this.payFilterPrefs;
    offcanvasRef.componentInstance.profile = this.profile;
    offcanvasRef.componentInstance.showLegalEntity = true;
    offcanvasRef.result.then((result: any) => {
      console.log('result => ', result);
      this.payFilterPrefs = applyBillingFilters(this.payFilterPrefs, result);
      this.p = 1;
      if (!this.godmode) this.payFilterPrefs.profile_id = this.profile.id;
      else delete this.payFilterPrefs.profile_id;
      this.payFilterPrefs.state = [1,2];
      this.payFilterPrefs.status = true;
      this.payFilterPrefs.all = true;
      this.loadBills(this.payFilterPrefs);
    });
  }

  resetFilters() {
    const adjustedDate = new Date(this.a.getFullYear(), this.a.getMonth(), this.a.getDate());
    const lastDay = new Date(this.a.getFullYear(), this.a.getMonth() + 1, 0);

    this.fromDate = new NgbDate(adjustedDate.getFullYear(), adjustedDate.getMonth()+1, 1);
    this.toDate = new NgbDate(this.a.getFullYear(), this.a.getMonth()+1, lastDay.getDate());
    // Reset to initial payload values
    this.payFilterPrefs = {
      page: 1,
      per_page: 50,
      status: true,
      state: [1,2],
      sort: 'created_at',
      order: 'DESC',
      all: true,
      created_at_since: this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day,
      created_at_to: this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day
    };

    if (!this.godmode) {
      this.payFilterPrefs.profile_id = this.profile.id; // Set profile_id for non-godmode users
    } else {
      delete this.payFilterPrefs.profile_id;
    }

    // Remove any additional filters
    delete this.payFilterPrefs.settlement_id;
    delete this.payFilterPrefs.building_id;
    delete this.payFilterPrefs.floor_id;
    delete this.payFilterPrefs.unit_id;

    // Reset page
    this.p = 1;

    // Reset active states on filter buttons
    this.oneDay?.nativeElement.classList.remove('active');
    this.yesterday?.nativeElement.classList.remove('active');
    this.oneMonth?.nativeElement.classList.add('active');
    this.threeMonth?.nativeElement.classList.remove('active');
    this.sixMonth?.nativeElement.classList.remove('active');
    this.twelveMonth?.nativeElement.classList.remove('active');
    this.custom?.nativeElement.classList.remove('active');

    // Update localStorage
    this.storageService.saveItem(STORAGE_KEYS.PAYFILTERSPREFS, this.payFilterPrefs);

    // Reload bills with reset filters
    this.loadBills(this.payFilterPrefs);
  }

  updateFilter(mes: number) {
    setTimeout(() => {
      this.datepicker.open();
    });

    if (mes === 0) {
      // Handle yesterday
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      
      this.fromDate = new NgbDate(yesterday.getFullYear(), yesterday.getMonth() + 1, yesterday.getDate());
      this.toDate = new NgbDate(yesterday.getFullYear(), yesterday.getMonth() + 1, yesterday.getDate());
      
      // Update active states
      this.oneDay.nativeElement.classList.remove('active');
      this.yesterday.nativeElement.classList.add('active');
      this.oneMonth.nativeElement.classList.remove('active');
      this.threeMonth.nativeElement.classList.remove('active');
      this.sixMonth.nativeElement.classList.remove('active');
      this.twelveMonth.nativeElement.classList.remove('active');
      this.custom.nativeElement.classList.remove('active');
    } else {
      const today = new Date();
      today.setMonth(today.getMonth() - mes);
      const adjustedDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const lastDay = new Date(this.a.getFullYear(), this.a.getMonth() + 1, 0);

      this.fromDate = new NgbDate(adjustedDate.getFullYear(), adjustedDate.getMonth()+1, 1);
      this.toDate = new NgbDate(this.a.getFullYear(), this.a.getMonth()+1, lastDay.getDate());

      this.payFilterPrefs.created_at_since = `${this.fromDate?.year}-${this.fromDate?.month}-${this.fromDate?.day}`;
      this.payFilterPrefs.created_at_to = `${this.toDate?.year}-${this.toDate?.month}-${this.toDate?.day}`;

      this.loadBills(this.payFilterPrefs);

      if (mes == 1) {
        this.oneMonth.nativeElement.classList.add('active');
        this.threeMonth.nativeElement.classList.remove('active');
        this.sixMonth.nativeElement.classList.remove('active');
        this.twelveMonth.nativeElement.classList.remove('active');
        this.custom.nativeElement.classList.remove('active');
      }
      if (mes == 3) {
        this.oneMonth.nativeElement.classList.remove('active');
        this.threeMonth.nativeElement.classList.add('active');
        this.sixMonth.nativeElement.classList.remove('active');
        this.twelveMonth.nativeElement.classList.remove('active');
        this.custom.nativeElement.classList.remove('active');
      }
      if (mes == 6) {
        this.oneMonth.nativeElement.classList.remove('active');
        this.threeMonth.nativeElement.classList.remove('active');
        this.sixMonth.nativeElement.classList.add('active');
        this.twelveMonth.nativeElement.classList.remove('active');
        this.custom.nativeElement.classList.remove('active');
      }
      if (mes == 12) {
        this.oneMonth.nativeElement.classList.remove('active');
        this.threeMonth.nativeElement.classList.remove('active');
        this.sixMonth.nativeElement.classList.remove('active');
        this.twelveMonth.nativeElement.classList.add('active');
        this.custom.nativeElement.classList.remove('active');
      }
    }
  }

  loadBillsBySettlement(settlement_id: any) {
    this.payFilterPrefs.settlement_id = settlement_id;    
    this.payFilterPrefs.page = 1;
    this.p = 1;

    delete this.payFilterPrefs.building_id;
    delete this.payFilterPrefs.floor_id;
    delete this.payFilterPrefs.unit_id;

    this.loadBills(this.payFilterPrefs);   
  }

  loadBillsByBuilding(building_id: any) {
    this.payFilterPrefs.building_id = building_id;
    this.payFilterPrefs.page = 1;
    this.p = 1;

    delete this.payFilterPrefs.floor_id;
    delete this.payFilterPrefs.unit_id;

    this.loadBills(this.payFilterPrefs);
  }

  loadBillsByFloor(floor_id: any) {
    this.payFilterPrefs.floor_id = floor_id;
    this.payFilterPrefs.page = 1;
    this.p = 1;

    delete this.payFilterPrefs.unit_id;

    this.loadBills(this.payFilterPrefs);
  }

  loadBillsByUnit(unit_id: any) {
    this.payFilterPrefs.unit_id = unit_id;
    this.payFilterPrefs.page = 1;
    this.p = 1;
    this.loadBills(this.payFilterPrefs);
  }

  clearFilter() {
    delete this.payFilterPrefs.legal_entity_id;
    this.payFilterPrefs.page = 1;
    this.p = 1;

    delete this.payFilterPrefs.settlement_id;
    delete this.payFilterPrefs.building_id;
    delete this.payFilterPrefs.floor_id;
    delete this.payFilterPrefs.unit_id;

    this.loadBills(this.payFilterPrefs);
  }

  pageChanged(event: any) {
    this.payFilterPrefs.page = event;
    this.loadBills(this.payFilterPrefs);
  }

  loadBillsSort(event: any) {
    this.payFilterPrefs.sort = event;
    this.loadBills(this.payFilterPrefs);
  }

  loadBillsOrder(event: any) {
    this.payFilterPrefs.order = event;
    this.loadBills(this.payFilterPrefs);
  }

  loadBillsPerPage(event: any) {
    this.payFilterPrefs.per_page = event;
    this.loadBills(this.payFilterPrefs);
  }

  gotoPayment(bill: any) {
    this.router.navigate(['/payments/pay', bill.id]);
  }

  updateBillDate(event: any) {
    this.selectedBill = event;
    new bs.Modal(<HTMLInputElement>document.getElementById('modalSetBillDate')).show();
  }

  updateList(event: any) {
    console.log("event: ", event);
    if (event.checked) {
      this.transactionList.push(event.transaction.id);
    } else {
      this.transactionList = this.transactionList.filter((id: any) => id !== event.transaction.id);    
    }
  }

  async downloadCSV() {
    this.downloading = true;
    // console.log('transactions => ', this.transactionList);
    // this.store.downloadTransactions({ list: this.transactionList }).subscribe((data: any) => {
    console.log('payload => ', this.payload);
    this.payload.per_page = 2000;
    let bills: any = {};

    let options = {
      title: 'Reporte de pagos',
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      noDownload: false,
      showTitle: true,
      useBom: true,
      headers: [
        "# Recibo",
        "Referencia",
        "Metodo pago",
        "Condominio",
        "Edificio",
        "Departamento",
        "Consumo LT",
        "Consumo M3",
        "Consumo $",
        "Lectura Ant.",
        "Lectura Act.",
        "Costo Admon.",
        "Precio Gas",
        "Adeudos",
        "Recargos",
        "Sub total",
        "IVA",
        "Total",
        "Fecha vencimiento",
        "Fecha pago",
        "Días periodo",
        "Factura"
      ]
    };

    if (this.payload.unit_id) {
      await this.store.getTransactionsByUnit(this.payload.unit_id, this.payload).subscribe(async (data: any) => {
        let datos: any = [];

        await data.data.map((bill: any) => {
          datos.push({
            id: bill.id,
            reference: bill.transaction_id,
            method_payment: bill.payment_method_brand,
            settlement_name: bill.settlement_name,
            building_name: bill.building_name,
            unit_name: bill.unit_name,
            consumo_lt: bill.consumo_lt,
            consumo_m3: bill.consumo_m3,
            consumo_total: bill.consumo_total,
            read_curr: bill.read_curr,
            read_prev: bill.read_prev,
            admin_price: bill.admin_price,
            gas_price: bill.gas_price,
            interests: bill.interests,
            recargos: bill.recargos,
            sub_total: bill.sub_total,
            taxes: bill.taxes,
            total: bill.total,
            due_date: bill.due_date,
            paid_date: bill.paid_date,
            days: bill.days,
            invoice_id: bill.invoice_id,
          });
        });

        new ngxCsv(datos, 'Reporte de transacciones', options);

        this.downloading = false;
      });
    } else if (this.payload.floor_id) {
      await this.store.getTransactionsByFloor(this.payload.floor_id, this.payload).subscribe(async (data: any) => {
        let datos: any = [];

        await data.data.map((bill: any) => {
          datos.push({
            id: bill.id,
            reference: bill.transaction_id,
            method_payment: bill.payment_method_brand,
            settlement_name: bill.settlement_name,
            building_name: bill.building_name,
            unit_name: bill.unit_name,
            consumo_lt: bill.consumo_lt,
            consumo_m3: bill.consumo_m3,
            consumo_total: bill.consumo_total,
            read_curr: bill.read_curr,
            read_prev: bill.read_prev,
            admin_price: bill.admin_price,
            gas_price: bill.gas_price,
            interests: bill.interests,
            recargos: bill.recargos,
            sub_total: bill.sub_total,
            taxes: bill.taxes,
            total: bill.total,
            due_date: bill.due_date,
            paid_date: bill.paid_date,
            days: bill.days,
            invoice_id: bill.invoice_id,
          });
        });

        new ngxCsv(datos, 'Reporte de transacciones', options);

        this.downloading = false;
      });
    } else if (this.payload.building_id) {
      await this.store.getTransactionsByBuilding(this.payload.building_id, this.payload).subscribe(async (data: any) => {
        let datos: any = [];

        await data.data.map((bill: any) => {
          datos.push({
            id: bill.id,
            reference: bill.transaction_id,
            method_payment: bill.payment_method_brand,
            settlement_name: bill.settlement_name,
            building_name: bill.building_name,
            unit_name: bill.unit_name,
            consumo_lt: bill.consumo_lt,
            consumo_m3: bill.consumo_m3,
            consumo_total: bill.consumo_total,
            read_curr: bill.read_curr,
            read_prev: bill.read_prev,
            admin_price: bill.admin_price,
            gas_price: bill.gas_price,
            interests: bill.interests,
            recargos: bill.recargos,
            sub_total: bill.sub_total,
            taxes: bill.taxes,
            total: bill.total,
            due_date: bill.due_date,
            paid_date: bill.paid_date,
            days: bill.days,
            invoice_id: bill.invoice_id,
          });
        });

        new ngxCsv(datos, 'Reporte de transacciones', options);

        this.downloading = false;
      });
    } else if (this.payload.settlement_id) {
      await this.store.getTransactionsBySettlement(this.payload.settlement_id, this.payload).subscribe(async (data: any) => {
        let datos: any = [];

      await data.data.map((bill: any) => {
        datos.push({
          id: bill.id,
          reference: bill.transaction_id,
          method_payment: bill.payment_method_brand,
          settlement_name: bill.settlement_name,
          building_name: bill.building_name,
          unit_name: bill.unit_name,
          consumo_lt: bill.consumo_lt,
          consumo_m3: bill.consumo_m3,
          consumo_total: bill.consumo_total,
          read_curr: bill.read_curr,
          read_prev: bill.read_prev,
          admin_price: bill.admin_price,
          gas_price: bill.gas_price,
          interests: bill.interests,
          recargos: bill.recargos,
          sub_total: bill.sub_total,
          taxes: bill.taxes,
          total: bill.total,
          due_date: bill.due_date,
          paid_date: bill.paid_date,
          days: bill.days,
          invoice_id: bill.invoice_id,
        });
      });

      new ngxCsv(datos, 'Reporte de transacciones', options);

      this.downloading = false;
      });
    } else {
      await this.store.getTransactionsQuery(this.payload).subscribe(async (data: any) => {
        let datos: any = [];

      await data.data.map((bill: any) => {
        datos.push({
          id: bill.id,
          reference: bill.transaction_id,
          method_payment: bill.payment_method_brand,
          settlement_name: bill.settlement_name,
          building_name: bill.building_name,
          unit_name: bill.unit_name,
          consumo_lt: bill.consumo_lt,
          consumo_m3: bill.consumo_m3,
          consumo_total: bill.consumo_total,
          read_curr: bill.read_curr,
          read_prev: bill.read_prev,
          admin_price: bill.admin_price,
          gas_price: bill.gas_price,
          interests: bill.interests,
          recargos: bill.recargos,
          sub_total: bill.sub_total,
          taxes: bill.taxes,
          total: bill.total,
          due_date: bill.due_date,
          paid_date: bill.paid_date,
          days: bill.days,
          invoice_id: bill.invoice_id,
        });
      });

      new ngxCsv(datos, 'Reporte de transacciones', options);

      this.downloading = false;
      });
    }

    this.payload.per_page = 100;
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
			this.fromDate = date;
		} else if (this.fromDate && !this.toDate && date) {
      this.toDate = date;
      if (this.fromDate.after(this.toDate)) {
        // If fromDate is after toDate, swap them
        const temp = this.fromDate;
        this.fromDate = this.toDate;
        this.toDate = temp;
      }
		} else {
			this.toDate = null;
			this.fromDate = date;
		}

    if (this.fromDate && this.toDate) {
      this.payFilterPrefs.created_at_since = `${this.fromDate.year}-${this.fromDate.month}-${this.fromDate.day}`;
      this.payFilterPrefs.created_at_to = `${this.toDate.year}-${this.toDate.month}-${this.toDate.day}`;
      this.loadBills(this.payFilterPrefs);
    }
	}

	isHovered(date: NgbDate) {
    return (
      this.fromDate && 
      !this.toDate && 
      this.hoveredDate && 
      date.after(this.fromDate) && 
      date.before(this.hoveredDate)
    );
  }

    isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  isInside(date: NgbDate) {
    return this.toDate && 
          date.after(this.fromDate) && 
          date.before(this.toDate);
  }

}
